<template>
    <div class="selector" ref="parent">
        <div class="smalltext base-f embrace-light">Available firms</div>
        <div class="font-s force-mako base-f" id="s2">Select the firms you are currently interested in, you can upgrade your account later.</div>
        <div v-if="true" class="pills">
            <button @click="changeCat(val)" class="pill" v-for="(key, val) in catMap" :key="key" :class="{active: currentCat === val}">
                <span>{{ key }}</span>
                <Motion class="bedy" layoutId="pill-active-indicator" v-if="currentCat === val" :transition="{ type: 'spring', bounce: 0.2, duration: 0.4 }">
                </Motion>
            </button>
        </div>
        <div v-if="true" class="firms">
            <div class="firm" v-for="(firm, index) in filtered" :key="index">
                <span class="label">
                    <div class="ico">
                        <img :src="logoUrl(firm.logo)" alt="">
                    </div>
                </span>
                <span class="name relative font-m base-f">
                    <span class="relative" :class="{free: firm.name === 'BNP Paribas'}">
                        {{firm.name.length > 17 ? firm.name.slice(0, 14) + '.' : firm.name}}
                    </span>
                </span>
                <span class="cat uiF font-m base-f force-mako">{{ formatCat(firm.category) }}</span>
                <a :href="linkMap[firm.name]" target="_blank" rel="noopener" style="text-decoration: none;" class="learn uiF font-m base-f force-mako flex-row-start-center _8">
                    Learn more
                    <svg class="" width="16" height="16" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" style="--icon-color: currentColor;"><path d="M7.184 3.894a.75.75 0 0 0-.136 1.494l2.295.209-4.879 4.878a.75.75 0 0 0 1.061 1.06l4.878-4.878.209 2.295a.75.75 0 1 0 1.494-.136l-.354-3.89a.75.75 0 0 0-.679-.678l-3.889-.354Z"></path></svg>
                </a>
                <span class="add">
                    <button @click="handleAct(firm.id)" class="addFirm s-btn btn-foreground" :class="{remove: selectedFirms.filter(f => f === firm.id).length != 0, disable: (firm.name === 'BNP Paribas' || firm.permitted)}">
                        <div class="flex-row-center-center _6" v-if="!(firm.name === 'BNP Paribas' || firm.permitted)" id="ag">
                            <svg v-show="selectedFirms.filter(f => f === firm.id).length === 0"  class="" style="--icon-color:#000" width="14" height="14" viewBox="0 0 16 16" fill="#000" role="img" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M8.75 4C8.75 3.58579 8.41421 3.25 8 3.25C7.58579 3.25 7.25 3.58579 7.25 4V7.25H4C3.58579 7.25 3.25 7.58579 3.25 8C3.25 8.41421 3.58579 8.75 4 8.75H7.25V12C7.25 12.4142 7.58579 12.75 8 12.75C8.41421 12.75 8.75 12.4142 8.75 12V8.75H12C12.4142 8.75 12.75 8.41421 12.75 8C12.75 7.58579 12.4142 7.25 12 7.25H8.75V4Z"></path></svg>
                            <svg v-show="selectedFirms.filter(f => f === firm.id).length !== 0" data-v-763ecc32="" viewBox="0 0 15 15" width="14" height="14" class="ml-2 h-4 w-4"><path data-v-763ecc32="" fill="currentColor" fill-rule="evenodd" d="M11.782 4.032a.575.575 0 1 0-.813-.814L7.5 6.687L4.032 3.218a.575.575 0 0 0-.814.814L6.687 7.5l-3.469 3.468a.575.575 0 0 0 .814.814L7.5 8.313l3.469 3.469a.575.575 0 0 0 .813-.814L8.313 7.5z" clip-rule="evenodd"></path></svg>
                            <span class="base-ft" v-show="selectedFirms.filter(f => f === firm.id).length === 0">Add</span>
                        </div>
                        <span class="base-ft" v-if="(firm.name === 'BNP Paribas' || firm.permitted)">Owned</span>
                    </button>
                </span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, watch } from 'vue';
import axios from 'axios';
import { Motion } from 'motion-v'; 
import { assetURL } from '@/store/state';
import { useCompaniesStore } from '@/store/companyStatic';

interface Firm {
    id: number
    route: string
    name: string
    category: string
    logo: string
    price: number
}

interface FirmWithPerm extends Firm {
    permitted: boolean
}

const currentCat = ref('all')
const firms = ref<Array<Firm>>([])
const firmsWithPerms = ref<Array<FirmWithPerm>>([])
const parent = ref<HTMLElement>()
const hideLearns = ref<boolean>(false);

const { isGraduating = 'false' } = defineProps<{ isGraduating: string }>();

onMounted(async () => {
    const path = `${import.meta.env.VITE_API_BASE}/public/companies`;
    const res = await axios.get(path)
    firms.value = res.data;
    if (parent.value) {
        if (parent.value.offsetWidth < 580) {
            hideLearns.value = true;
        }
    }

    if (isGraduating === 'false') {
        const cached_pack = JSON.parse(localStorage.getItem('cached_pack') as string)
        if (cached_pack) selectedFirms.value = cached_pack;

        const permissions = useCompaniesStore().preferences;
        firmsWithPerms.value = firms.value.map(firm => ({
            ...firm,
            permitted: permissions[firm.id] ? permissions[firm.id].permitted : false
        }))
    } else {
        firmsWithPerms.value = firms.value.map(firm => ({
            ...firm,
            permitted: false
        }))
    }
})

const changeCat = (cat: string) => {
    currentCat.value = cat
}

const catMap: Record<string, string> = {"all": "All", "investment_banks" : "IBD", "consulting": "Consulting", "private_equity": "PE", "hfs": "HFs", "assets": "AMg", "big4": "Big4" }
const formatCat = (raw: string) => {
    return catMap[raw]
}

const filtered = computed(() => {
    const catFiltered = currentCat.value === 'all' ? firmsWithPerms.value : firmsWithPerms.value.filter(f => f.category === currentCat.value)
    return catFiltered
})

const selectedFirms = ref<Array<number>>([])
const handleAct = (id: number) => {
    if (id === 1) return;
    const idx = selectedFirms.value.findIndex(f => f === id)
    if (idx === -1) {
        selectedFirms.value.push(id)
        totalPrice.value += 12
    } else {
        selectedFirms.value.splice(idx, 1)
        totalPrice.value -= 12
    }
}

const totalPrice = ref<number>(0)
const logoBase = assetURL('companies')
const logoUrl = (file: string) => logoBase + file

const emit = defineEmits<{
    (e: 'updatedSelection', val: number[]) : void
}>();

const payload = computed(() => {
    const firm_array: number[] = [];
    selectedFirms.value.forEach((id) => firm_array.push(id))
    return firm_array
})

watch(payload, (newVal) => {
    if (newVal) localStorage.setItem('cached_pack', JSON.stringify(payload.value))
    emit('updatedSelection', newVal)
})

const linkMap: Record<string, string> = {
    'BNP Paribas': 'https://group.bnpparibas/en/',
    'Barclays': 'https://www.barclays.co.uk/',
    'BCG': 'https://www.bcg.com/',
    'Blackstone': 'https://www.blackstone.com/',
    'Citadel Securities': 'https://www.citadelsecurities.com/',
    'Citibank': 'https://www.citigroup.com/global',
    'Crédit Agricole': 'https://www.credit-agricole.fr/',
    'Deloitte': 'https://www.deloitte.com/global/en.html?icid=site_selector_global',
    'Deutsche Bank': 'https://www.db.com/',
    'EY': 'https://www.ey.com/en_gl',
    'Fidelity': 'https://www.fidelityinternational.com/',
    'Houlihan Lokey': 'https://hl.com/',
    'HSBC': 'https://www.hsbc.com/',
    'Jefferies': 'https://www.jefferies.com/',
    'J.P. Morgan': 'https://www.jpmorgan.com/GB/en/about-us',
    'KPMG': 'https://kpmg.com/xx/en.html',
    'Lazard': 'https://lazard.com/',
    'Macquarie': 'https://www.macquarie.com/uk/en.html',
    'McKinsey & Co.': 'https://www.mckinsey.com/',
    'Morgan Stanley': 'https://www.morganstanley.com/',
    'Moelis & Co.': 'https://www.moelis.com/',
    'Nomura': 'https://www.nomura.com/',
    'PwC': 'https://www.pwc.com/gx/en.html',
    'PJT Partners': 'https://www.pjtpartners.com/',
    'RBC': 'https://www.rbc.com/about-rbc.html',
    'Rothschild & Co.': 'https://www.rothschildandco.com/',
    'Santander': 'https://www.santander.com/en/home',
    'Schroders': 'https://www.schroders.com/en/global/individual/',
    'Standard Chartered': 'https://www.sc.com/en/',
    'UBS': 'https://www.ubs.com/uk/en.html',
    'Wells Fargo': 'https://www.wellsfargo.com/',
}

</script>

<style scoped>
.selector {
    width: fit-content;
    height: inherit;
    max-height: calc(100vh - 72px) !important;
    background-color: var(--contrast_bg);
    border-radius: 12px;
    border: 1px solid var(--gutil);
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.10);
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    animation: .4s ease 1 normal both running RmeheTop;
    animation-delay: 0.6s;
}
.pills {
    display: flex;
    width: fit-content;
    justify-content: start;
    gap: 12px;
    padding: 4px;
    background-color: var(--bg);
    border-radius: 0.5rem;
    border: 1px solid var(--gutil);
    margin-top: 12px;
}
.pill {
    padding: 0.3rem 0.6rem;
    border-radius: 8px;
    cursor: pointer;
    border: 1px solid transparent;
    background-color: transparent;
    user-select: none;
    position: relative;
}
.pill span {
  position: relative;
  z-index: 11;
  font-family: "Inter";
  font-size: 14px;
  letter-spacing: -0.013em;
  font-weight: 510;
  font-variation-settings: "opsz" 28;
  color: var(--mako);
}
.pill.active span {
  color: var(--foreground);
}
.firms {
    width: 100%;
    padding-top: 12px;
    height: stretch;
    overflow-y: scroll;
}
.firm {
    padding: 12px 8px;
    width: 100%;
    border-top: 1px solid var(--gutil);
    display: grid;
    align-items: center;
    grid-template-columns: auto 1.25fr 1fr 1fr 1fr;
}
.label {
    height: fit-content;
    margin-right: 16px;
}
.ico {
    height: 32px;
    width: 32px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--gutil);
}
.ico img {
    width: 28px;
    height: 28px;
}
.relative.free::after {
    content: "free";
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    position: absolute;
    left: calc(100% + 4px);
    top: 0;
    background-color: var(--primary);
    color: #fff;
    border-radius: 4px;
    padding: 2px 6px;
}
.uiF {
    letter-spacing: -0.013em;
    color: var(--foreground);
}
.learn {
    color: var(--mako);
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
}
.learn svg {
    transition: 160ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
    transition-property: transform;
}
.learn:hover svg {
    transform: rotate(45deg);
}
.add {
    display: flex;
    justify-content: end;
}
.addFirm.disable {
    background-color: rgba(0,0,0,0.05);
    pointer-events: none;
    color: #555 !important;
}
.addFirm.remove {
    background-color: #e5484d;
}
.smalltext {
    font-size: 18px;
}
.bedy {
  position: absolute;
  border: 1px solid var(--gutil);
  inset: 0;
  z-index: 10;
  background-color: var(--contrast_bg);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
#s2 {
    margin-top: 8px;
}
</style>